module.exports = __webpack_public_path__ + "7074d7335d2b8d51af7fc222f446fa9c.MP3";